import { getIsLostLeadModalVisible } from '@bridebook/web/lib/ui/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';

const LostLeadModalLazy = lazyComponent(() => import('./lost-lead-modal'));

export const LostLeadModal = () => {
  const showModal = useSelector(getIsLostLeadModalVisible);

  if (!showModal) {
    return null;
  }

  return <LostLeadModalLazy />;
};
